import { useEffect } from 'react'
import { useLocation } from 'react-router'

export function ScrollRestoration () {
  const location = useLocation()

  // This is a quick way to ensure the scroll position is reset to the top
  // when the user navigates to a new page with client-side routing. However,
  // it will fall apart if a page dynamically sets search params in the URL
  // (for example, maybe in a filtering interface that persists the filters to
  // the URL). In that case, the scroll position will be reset to the top each
  // time the search params change, which is probably not what we want.
  //
  // At the moment, this app doesn't set/update search params so we're fine, but
  // if we ever do we'll need to find a different solution for scroll resets.
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return null
}
